module.exports = __webpack_public_path__ + "assets/sonography.687ed8c9.svg";